import React from 'react'
import injectSheet from 'react-jss'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'

const styleSheet = theme => ({
    vimeoPlayer: {
        width: '100%',
        height: '100%',
    },

    vimeoIframeContainer: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.common.black,
    },
})

const style = injectSheet(styleSheet)

const VimeoPlayer = ({ classes, title, src }) => (
    <div className={classes.vimeoPlayer}>
        <iframe
            className={classes.vimeoIframeContainer}
            title={title}
            src={src}
            allowFullScreen
            allowTransparency
            allow="autoplay"
        />
    </div>
)

VimeoPlayer.defaultProps = {
    title: '',
    src: '',
}

VimeoPlayer.propTypes = {
    title: PropTypes.string,
    src: PropTypes.string,
}

export default compose(style)(VimeoPlayer)
